export default "__VITE_ASSET__dE2$06yZ__"